import { z } from 'zod';

import { Status } from '../lib/types';

export const StatusSchema = z.nativeEnum(Status);

const PaginatedResponseSchema = <TData extends z.ZodTypeAny>(data: TData) =>
  z.object({
    total: z.number(),
    data: z.array(data),
  });

export const DDEXImportItemResponse = z.object({
  status: z.string(),
  id: z.string(),
  label_name: z.string(),
  external_id: z.string(),
  package_id: z.string(),
  partner_name: z.string(),
  title: z.string().nullable(),
  artist_name: z.string().nullable(),
  release_type: z.string().nullable(),
  release_subtype: z.string().nullable(),
  release_format: z.string().nullable(),
  downstream_id: z.string().nullable(),
  status_message: z.string().nullable(),
  created_at: z.string(),
  received_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});

export const DdexImportSchema = DDEXImportItemResponse.transform((data) => ({
  id: data.id,
  downstreamId: data.downstream_id,
  externalId: data.external_id,
  packageId: data.package_id,
  status: StatusSchema.safeParse(data.status).success
    ? (data.status as Status)
    : Status.needs_attention,
  statusMessage: data.status_message ?? '',
  labelName: data.label_name,
  partnerName: data.partner_name,
  title: data.title ?? '',
  artistName: data.artist_name ?? '',
  releaseType: data.release_type ?? '',
  releaseSubtype: data.release_subtype ?? '',
  releaseFormat: data.release_format ?? '',
  receivedAt: data.received_at,
  createdAt: data.created_at,
  updatedAt: data.updated_at,
}));

export type DdexImport = z.infer<typeof DdexImportSchema>;

export const DdexImportListSchema = PaginatedResponseSchema(DdexImportSchema);

export type DdexImportList = z.infer<typeof DdexImportListSchema>;

export const DdexPermissionsSchema = z.object({
  'can.view.console': z.boolean(),
});

export type DdexPermissions = z.infer<typeof DdexPermissionsSchema>;
